const criteriaRouter = [
    {
        path: "list-criteria",
        name: "criteria",
        component: () => import("@/views/admin/criteria"),
        default: true,
        meta: {
            model: "criteria",
            // requiresAuth: true,
        },
    },
    {
        path: "list-criteria/add",
        name: "addCriteria",
        component: () => import("@/views/admin/criteria/function"),
        default: true,
        meta: {
            model: "criteria",
            // requiresAuth: true,
        },
    },
    {
        path: "list-criteria/edit/:id",
        name: "editCriteria",
        component: () => import("@/views/admin/criteria/function"),
        default: true,
        meta: {
            model: "criteria",
            // requiresAuth: true,
        },
    }
]
export default criteriaRouter;